<template>
	<md-field :class="[{ 'md-error': error }]">
		<label>{{ labelText }}</label>
		<TbSelect
			v-model="moduleValue"
			@md-selected="onSelect"
			:search-allow="true"
			:options="options"
			options-value-field="id"
			:options-display-getter="(item) => $t(item.translationKey)"
			:no-entries-text="!country ? $t('common.select.countryRequired') : ''"
			content-size="xl"
			:disabled="disabled"
			:required="required"
			:blacklistFunction="blacklistFunction"
		/>
		<span v-if="error" class="validation-error">{{ error }}</span>
	</md-field>
</template>
<script>
import {commonApi} from "@/common/api/commonApi";

export default {
	props: {
		country: [String, Number],
		disabled: { type: Boolean, default: false },
		labelText: { type: String, default: "value" },
		required: { type: Boolean, default: false },
		error: { type: Boolean, default: "" },
		value: { type: String, default: "" },
		companyType: { type: Number },
		blacklistFunction: { type: Function, default: null }
	},
	data() {
		return {
			moduleValue: "",
			options: []
		};
	},
	mounted() {
		this.moduleValue = this.value;
		this.getList();
	},
	methods: {
		getList() {
			if (!this.country) {
				this.options = [];
				this.value = "";
				return;
			}

			commonApi.getLegalStructures(this.companyType, this.country)
				.then(res => {
					this.options = res;
					
					if (this.isValueInOptions(this.value)) {
						this.moduleValue = this.value;
					} else {
						// This is typically the case when the country changed
						this.moduleValue = null;
					}
				});
		},
		isValueInOptions(value) {
			return this.options.find(item => item.id === value) !== undefined;
		},
		onSelect() {
			this.$emit("input", this.moduleValue);
		}
	},
	watch: {
		country() {
			this.getList();
		},
		value() {
			this.moduleValue = this.value;
		}
	}
};
</script>
